import { render } from "./SectionEnd.vue?vue&type=template&id=3d51cef0"
import script from "./SectionEnd.vue?vue&type=script&lang=js"
export * from "./SectionEnd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__